module.exports = __webpack_public_path__ + "static/img/ikonaCwiczenieDisabled-OFF.617119ce.png";